import AboutPage from './about';
import AccountPage from './account';
import AddressPage from './address';
import AddressesPage from './addresses';
import ApprovalPage from './approval';
import ApprovalsPage from './approvals';
import BankingPage from './banking';
import BenefitsPage from './benefits';
import BlankPage from './blank';
import ClientPage from './client';
import ClientsPage from './clients';
import CompanyPage from './company';
import ContactsPage from './contacts';
import DocumentsPage from './documents';
import DashboardPage from './dashboard';
import ExpensesPage from './expenses';
import HelpPage from './help';
import LeavesPage from './leaves';
import MessagesPage from './messages';
import OnboardingPage from './onboarding';
import PaymentsPage from './payments';
import PositionsPage from './positions';
import PositionPage from './position';
import ProfilePage from './profile';
import ReportsPage from './reports';
import SettingsPage from './settings';
import TimeKeepingPage from './timekeeping';
import UserPage from './user';
import UsersPage from './users';
import WorkerPage from './worker';
import PayStubsPage from './paystubs';
import InvoicesPage from './invoices';
import InvoicePage from './invoice';
import ProjectsPage from './projects';
import PayDuePage from './payDue';
import PayrollsPage from './payrolls';

import { finishesWith } from '../utilities/string';

export {
    AboutPage,
    AccountPage,
    AddressPage,
    AddressesPage,
    ApprovalPage,
    ApprovalsPage,
    BankingPage,
    BenefitsPage,
    BlankPage,
    ClientPage,
    ClientsPage,
    CompanyPage,
    ContactsPage,
    DocumentsPage,
    DashboardPage,
    ExpensesPage,
    HelpPage,
    LeavesPage,
    MessagesPage,
    OnboardingPage,
    PaymentsPage,
    PositionsPage,
    PositionPage,
    ProfilePage,
    ReportsPage,
    SettingsPage,
    TimeKeepingPage,
    UsersPage,
    UserPage,
    WorkerPage,
    PayStubsPage,
    InvoicesPage,
    InvoicePage,
    PayrollsPage,
    ProjectsPage,
    PayDuePage
};

export function getNavigablePagesMetadata() {
    let exports = require('./');
    let pages = {};
    for (const property in exports) {
        if (exports.hasOwnProperty(property) && finishesWith(property, 'Page')) {
            const page = exports[property];
            if (!page.meta) {
                continue;
            }

            let name = property.replace('Page', '').toLowerCase();
            pages[name] = page.meta;
        }
    }

    return pages;
}



// WEBPACK FOOTER //
// ./src/pages/index.jsx